import { parseJwtCompanies } from "./parse-jwt-companies";
import type { TitleJournalOrgCheckInput } from "./title-journal-org-check.types";
import { resolveUserTitleCompanyMatch } from "./title-journal-user-company";

export function userHasOrganizationOnTitlePage(
  titleJournal: TitleJournalOrgCheckInput,
  authToken: string | null | undefined,
): boolean {
  return resolveUserTitleCompanyMatch(
    titleJournal,
    parseJwtCompanies(authToken),
  );
}
